import React from "react";
import "./LogoutButton.css";
import { IoIosLogOut } from "react-icons/io";

const LogoutButton = ({ onLogout }) => {
  const handleLogout = () => {
    sessionStorage.clear();
    onLogout();
  };

  return (
    <div className="flex-grow-1 d-flex ">
      <button onClick={handleLogout} className="btn  btn-narrow text-center text-white">
        <IoIosLogOut className="logout-icon" /> Logga ut
      </button>
    </div>
  );
};

export default LogoutButton;
